import React from 'react';
import {twMerge} from 'tailwind-merge';

export const SettingIndentedRow = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={twMerge(
        'flex flex-col',
        'border-l-2 border-wb-border-strong',
        'ml-10',
        className
      )}>
      {children}
    </div>
  );
};
